import React from 'react';
import { useFragment, graphql } from 'react-relay/hooks';
import UserNameLabel from '~/components/UserNameLabel';
export const User = (props) => {
    const user = useFragment(graphql `
      fragment User_user on User {
        ...UserNameLabel_user
        id
      }
    `, props.user);
    return (<strong style={{ fontWeight: 'bold' }}>
      <UserNameLabel user={user}/>
    </strong>);
};
export default User;
